export default __webpack_public_path__ + "static/media/_DSC0288.a5c8588a.JPG";